var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(this.$store.state.showGlobalLoader)?_c('GlobalLoader'):_vm._e(),_c('router-view'),_c('div',{staticClass:"btn-feedback",on:{"click":_vm.openFeedback}},[_vm._v("Help & Feedback")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }